<template>
	<div class="primary-main city-list">
		<div class="tree-block">
			<div class="block-scroll">
				<el-tree :data="tree" node-key="id" :default-expanded-keys="[-1,-1]" :props="defaultProps" @node-click="handleNodeClick"></el-tree>
			</div>
		</div>
		<div class="tb-region">
			<el-breadcrumb separator-class="el-icon-arrow-right">
			  <el-breadcrumb-item v-for="(item,index) in dhList" :key="index">{{item}}</el-breadcrumb-item>
			</el-breadcrumb>
			<div class="top-forward">
				<el-input v-model="csbm" placeholder="请输入城市编码" clearable class="minor-input"></el-input>
				<el-input v-model="csmc" placeholder="请输入城市名称" clearable class="minor-input"></el-input>
				<el-button @click="cityList()" type="primary" icon="el-icon-search">查询</el-button>
				<div style="float: right;">
					<!-- <el-button type="primary" style="margin-right: 10px;" icon="el-icon-download">导出</el-button> -->
					<el-button type="primary" @click="cityDialogshow = true" icon="el-icon-circle-plus-outline">添加城市</el-button>
				</div>
			</div>
			<div class="middle-body">
				<el-table :data="cityLists" border style="width: 100%;" height="500">
					<el-table-column prop="csmc" align="center" label="城市名称"></el-table-column>
					<el-table-column prop="csbm" align="center" label="城市编码"></el-table-column>
					<el-table-column label="操作" align="center" width="150">
					  <template slot-scope="scope">
					  	<span class="oprate-txt" @click="cityView(scope.row.id)">修改</span>
					  	<span class="oprate-txt" @click="cityDel(scope.row.id)">删除</span>
					  </template>
					</el-table-column>
				</el-table>
			</div>
		</div>
		<city-dialog v-if="cityDialogshow" ref="citydata"></city-dialog>
	</div>
</template>

<script>
import cityDialog from '@/components/CityDialog'
export default {
	name: 'cityList',
	data() {
	  return {
      csid:'',	//城市id
      csviews:[],//城市详情
      csbm:'',	//城市编码
      csmc:'',	//城市名称
      cityLists: [],	//城市列表
      cityDialogshow: false,
      tree: [],
      //用于定义配置选项
      defaultProps: {
        children: 'children',
        label: 'csmc'
      },
      dhList: ['城市']  //面包屑list
	  }
	},
	components: {cityDialog},
	mounted: function() {
		this.treeList();//城市树形菜单
	},
	methods: {
		treeList(){//城市树形菜单
			this.$get("admin/CityController/cityTree").then(response => {
				if(response.code == "1"){
					this.tree = response.result.childrenList;
					if(this.tree.length > 0){
						if(this.csid == ''){
							this.csid = this.tree[0].id;
						}
						this.cityList();//城市列表
					}
				}else {
					this.$message({
						type: "error",
						message: response.msg
					})
				}
			})
		},
		handleNodeClick(data,node) {
			this.dhList=[];
			this.dhList.push(data.csmc);
			var tnode = node.parent;
			for(var i=0;i<node.level-1;i++){
				this.dhList.push(tnode.data.csmc);
				tnode = tnode.parent;
			}
			this.dhList.reverse();
			this.csid = data.id;
			this.cityList();
		},
    cityList(){//城市列表
			var param = {
				id: this.csid,
				csbm:this.csbm,
				csmc:this.csmc
			}
			this.$get("admin/CityController/cityList",param).then(response => {
				if(response.code == "1"){
					this.cityLists = response.result.cityList;
				}else {
					this.$message({
						type: "error",
						message: response.msg
					})
				}
			})
		},
		cityDel(id){//删除城市
			this.$confirm('是否确认删除', '提示', {
			  confirmButtonText: '确定',
			  cancelButtonText: '取消',
			  type: 'warning'
			}).then(() => {
				this.$post("admin/CityController/cityDel",{id:id}).then(response => {
					if(response.code == "1"){
						this.$message({
							type: 'success',
							message: '删除成功!'
						});
						this.treeList();
						this.cityList();
					}else{
						this.$message({
							type: "error",
							message: response.msg
						});
					}
				})
			}).catch(() => {
			  this.$message({
				type: 'info',
				message: '已取消'
			  });
			})
		},
		cityView(id){//城市详情查看
			this.cityDialogshow = true;
			this.$post("admin/CityController/cityView",{id:id}).then(response => {
				if(response.code == "1"){
					this.cityviews = response.result.city;
					this.$refs.citydata.form.csid = id;
					this.$refs.citydata.form.csbm = this.cityviews.csbm;
					this.$refs.citydata.form.csmc = this.cityviews.csmc;
					this.fcsid = this.cityviews.fcsid;
				}else {
					this.$message({
						type: "error",
						message: response.msg
					})
				}
			})
		}
	}
}
</script>

<style lang="less">
	.city-list{
		height: 100%;
		.tree-block{
			width: 200px;
			height: 100%;
			border-right: 1px solid #D7D7D7;
			float: left;
			max-width: 200px;
			.block-scroll{
				height: 100%;
				width: 199px;
				overflow: auto;
				.el-tree{
					overflow: auto;
					padding-top: 10px;
					display: inline-block;
					min-width: 100%;
				}
			}
		}
    .oprate-txt{
      color: #03A9F4;
      padding: 0 5px;
      cursor: pointer;
      width: 40px;
      display: inline-block;
    }
		.block-scroll::-webkit-scrollbar{
			width: 5px;
			height: 5px;
		}
		.block-scroll::-webkit-scrollbar-thumb{
			border-radius   : 10px;
			background-color: #03a9f4;
		}
		.block-scroll::-webkit-scrollbar-track{
		  box-shadow   : inset 0 0 5px rgba(0, 0, 0, 0.2);
		  background   : #ededed;
		  border-radius: 10px;
		}
		.tb-region{
			margin-left: 200px;
			height: 100%;
			overflow: auto;
			.top-forward{
				text-align: left;
				margin: 0px 15px;
				.minor-input{
					width: 18%;
					margin-right: 10px;
				}
			}
			.middle-body{
				margin: 15px;
				.el-pagination{
					height: 36px;
					text-align: right;
					margin-top: 20px;
				}
			}
			.el-breadcrumb{
				height: 56px;
				padding-top: 20px;
				padding-bottom: 10px;
				margin: 0 15px;
			}
		}
	}
</style>